import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import * as loginActions from '../../Actions/login';
import { Link } from 'react-router';
import logo from '../../Content/ZemaLogoWhite.png';

class TopHeader extends Component {
  logout() {

    this.props.doLogout();

    if (localStorage.getItem("boleto@dataUser"))
      localStorage.removeItem("boleto@dataUser");

    browserHistory.push('/login');

  }

  render() {
      return (
        <div id="top-header">
          <div className="container">
            <ul className="header-links pull-left">
              <li>
                <Link to="/" className="logo">
                  <img src={logo} alt="Logo Zema" title="Logo Zema" />
                </Link>

              </li>
            </ul>
            {/* <ul className="header-links col-12 text-center">
            <li>
              <a href="#a">
               Emissão Segunda Via Boletos Zema
              </a>
            </li>
          </ul>*/}

            <ul className={"header-links pull-right"}>
              <li>
                <a onClick={this.logout.bind(this)} style={{ cursor: 'pointer' }}>
                  <i className="fa fa-sign-out" /> Sair
                </a>
              </li>

            </ul>
          </div>
        </div>
      );
    
  }
}

const mapStateToProps = state => ({ login: state.login });
const mapDispatchToProps = dispatch => bindActionCreators({ ...loginActions }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopHeader));


// WEBPACK FOOTER //
// ./src/Components/Layout/TopHeader.js